<template>
  <div class="share-wrapper" @click="closeWrapper">
    <div :class="{'share-box': true, closeAnimation}">

      <div class="top-row">
        <div class="title">{{ title }}</div>
        <div class="close">
          <font-awesome-icon icon="times" class="icon" @click="close"/>
        </div>
      </div>

      <div class="bottom-row">
        <div class="copy-main">
          <input type="text" class="link-input" :value="link" readonly @focus="selectText">
          <div class="buttons">
            <button @click="copyLink" class="copy">Copy Link</button>
            <button @click="openLink" class="open" title="Open in new tab">
              <font-awesome-icon icon="globe" class="icon"/>
            </button>
          </div>
        </div>
        <div class="copy-success">
          <span v-if="copied">Link copied!</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareWrapper',
  props: {
    title: String,
    link: String
  },
  data() {
    return {
      copied: false,
      closeAnimation: false
    }
  },
  methods: {
    selectText(event) {
      event.target.select();
    },
    copyLink() {
      document.querySelector('.link-input').select();
      document.execCommand('copy');
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 5000);
    },
    openLink() {
      window.open(this.link);
    },
    closeWrapper(event) {
      if(event.target == document.querySelector('.share-wrapper')) {
        this.close();
      }
    },
    close() {
      this.closeAnimation = true;
      setTimeout(() => {
        this.$emit('close');
      }, 300);
    }
  }
}
</script>

<style lang="scss" scoped>
  .share-wrapper {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: #2526295b;
    z-index: 90;
    display: flex;
    justify-content: center;
    align-items: center;

    .share-box {
      z-index: 100;
      width: 30rem;
      height: 13rem;
      background-color: whitesmoke;
      border-radius: 0.2rem;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      animation: open 0.5s forwards;

      @media (max-width: 600px) {
        width: 90vw;
        height: 19rem;
        position: absolute;
        top: 10rem;
      }

      @keyframes open {
        0% {
          opacity: 0;
          transform: translateY(5rem);
        }
        100% {
          opacity: 1;
          transform: translateY(0rem);
        }
      }
    }

    .closeAnimation {
      animation: close 0.5s forwards;

      @keyframes close {
        0% {
          opacity: 1;
          transform: translateY(0rem);
        }
        100% {
          opacity: 0;
          transform: translateY(-5rem);
        }
      }
    }

    .top-row {
      width: 100%;
      height: 5rem;
      background-color: #11b6a5;
      display: flex;
      flex-direction: row;

      .title {
        flex: auto;
        height: 100%;
        display: flex;
        align-items: center;
        color: white;
        font-size: 1.5rem;
        padding-left: 2rem;
      }

      .close {
        width: 5rem;
        height: 5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 1.2rem;

        .icon {
          transition: 0.2s;

          &:hover {
            opacity: 0.8;
            cursor: pointer;
          }
        }
      }
    }

    .bottom-row {
      width: 100%;
      height: 8rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 600px) {
        height: 14rem;
      }

      .copy-main {
        margin-top: 1rem;
        display: flex;
        flex-direction: row;
        @media (max-width: 600px) {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
      }

      .copy-success {
        width: 26rem;
        height: 2rem;
        display: flex;
        align-items: flex-end;
        color: #25262980;
        font-weight: bold;
        padding-bottom: 0.1rem;
        @media (max-width: 600px) {
          width: 100%;
          height: 3rem;
          justify-content: center;
        }
      }

      input {
        width: 16rem;
        height: 2.5rem;
        outline: none;
        background: none;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        font-size: 1rem;
        color: #252629;
        border-style: solid;
        border-color: #252629;
        border-radius: 0.1rem;
        transition: 0.2s;
        @media (max-width: 600px) {
          width: 75vw;
          height: 3rem;
        }

        &:focus {
          border-color: #ebc659;
        }
      }

      .buttons {
        width: auto;
        height: 2.5rem;
        display: flex;
        flex-direction: row;
        @media (max-width: 600px) {
          width: 75vw;
          margin-top: 1.5rem;
          justify-content: space-between;
        }
      }

      .copy {
        width: 6rem;
        height: 2.5rem;
        border: none;
        background-color: #11b6a5;
        outline: none;
        border-radius: 0.2rem;
        color: white;
        font-weight: bold;
        font-size: 1rem;
        transition: 0.2s;
        margin-left: 1rem;

        @media (max-width: 600px) {
          margin-left: 0rem;
          width: 45%;
          height: 3rem;
        }

        &:hover {
          cursor: pointer;
          background-color: #0f978a;
        }
      }

      .open {
        width: 2.5rem;
        height: 2.5rem;
        border: none;
        background-color: #11b6a5;
        outline: none;
        border-radius: 0.2rem;
        color: white;
        font-weight: bold;
        font-size: 1.2rem;
        transition: 0.2s;
        margin-left: 0.5rem;

        @media (max-width: 600px) {
          margin-left: 0rem;
          width: 45%;
          height: 3rem;
        }

        &:hover {
          cursor: pointer;
          background-color: #0f978a;
        }
      }
    }
  }
  
</style>